import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {DIAGNOSIS_VERSION_LABELS} from '@/features/projects/diagnosisVersion'
import {Diagnosis, MappedDiagnosisCode} from '@/features/projects/types'

interface DiagnosisCodeLabelProps {
    diagnosis?: Diagnosis | MappedDiagnosisCode | null
}

/**
 * A diagnosis in read mode: version badge, code and description. Both classifications are rendered
 * through this, so an ICD-10 reads exactly like an ICD-9.
 */
export const DiagnosisCodeLabel = ({diagnosis}: DiagnosisCodeLabelProps) => {
    if (!diagnosis) {
        return null
    }

    return (
        <Flexbox gap={2} align="center">
            {/* Fixed width so the ICD-9 and ICD-10 badges match and the codes beside them line up
                vertically, despite the two labels having different lengths. */}
            <Badge size="sm" shape="rectangle" style={{minWidth: 55}}>
                {DIAGNOSIS_VERSION_LABELS[diagnosis.version]}
            </Badge>
            <Text size="textSm" weight="500">
                {diagnosis.code} - {diagnosis.description}
            </Text>
        </Flexbox>
    )
}
